import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import Logo from "../../assets/Images/favicon.ico";
import useSettings from "../../hooks/useSettings";
import { Nav_Buttons, Nav_Setting } from "../../data";
import ProfileMenu from "./ProfileMenu";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UpdateTab } from "../../redux/slices/app";

const getPath = (index) => {
  switch (index) {
    case 0:
      return "/app";

    case 1:
      return "/group";

    case 2:
      return "/call";

    case 3:
      return "/settings";

    default:
      break;
  }
};

const SideBar = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const { tab } = useSelector((state) => state.app);

  const navigate = useNavigate();

  const { onToggleMode } = useSettings();

  const selectedTab = tab;

  const handleChangeTab = (index) => {
    dispatch(UpdateTab({ tab: index }));
    navigate(getPath(index));
  };

  return (
    <Box
      sx={{
        height: "100vh",
        width: 100,

        backgroundColor:
          theme.palette.mode === "light"
            ? "#F0F4FA"
            : theme.palette.background.paper,
        boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
      }}
    >
      <Stack
        py={3}
        alignItems={"center"}
        justifyContent="space-between"
        sx={{ height: "100%" }}
      >
        <Stack alignItems={"center"} spacing={4}>
          <Avatar
            size={20}
            src={Logo}
            onClick={() => {
              navigate("/app");
            }}
            sx={{
              border: "2px solid",
              borderColor:
                theme.palette.mode === "light" ? "transparent" : "#ffffff",
              backgroundColor:
                theme.palette.mode === "dark" ? "#ffffff" : "transparent",
            }}
          />

          <Stack
            sx={{ width: "max-content" }}
            direction="column"
            alignItems={"center"}
            spacing={3}
          >
            {Nav_Buttons.map((el, idx) => (
              <Box
                key={idx} // Sửa key thành idx
                sx={{
                  backgroundColor:
                    el.index === selectedTab
                      ? theme.palette.primary.main
                      : undefined,
                  borderRadius: 1.5,
                }}
                p={1}
              >
                <IconButton
                  onClick={() => {
                    handleChangeTab(el.index);
                  }}
                  sx={{
                    width: "max-content",
                    color:
                      el.index === selectedTab
                        ? "#ffffff"
                        : theme.palette.mode === "light"
                        ? "#080707"
                        : theme.palette.text.primary,
                  }}
                >
                  {el.icon}
                </IconButton>
              </Box>
            ))}

            <Divider
              sx={{ width: 48, borderWidth: 0.25, borderColor: "grey.400" }}
            />
            {Nav_Setting.map((el) => (
              <Box
                key={el.index} // Sửa key thành el.index
                sx={{
                  backgroundColor:
                    el.index === selectedTab
                      ? theme.palette.primary.main
                      : undefined,
                  borderRadius: 1.5,
                }}
                p={1}
              >
                <IconButton
                  onClick={() => {
                    handleChangeTab(el.index);
                  }}
                  sx={{
                    width: "max-content",
                    color:
                      el.index === selectedTab
                        ? "#ffffff"
                        : theme.palette.mode === "light"
                        ? "#080707"
                        : theme.palette.text.primary,
                  }}
                >
                  {el.icon}
                </IconButton>
              </Box>
            ))}
          </Stack>
        </Stack>
        <Stack spacing={4}>
          {/* Profile Menu */}
          <ProfileMenu />
        </Stack>
      </Stack>
    </Box>
  );
};

export default SideBar;
